
import { Loader2 } from "lucide-react";
import KPICards from "../KPICards";
import StorageLocationOverview from "../StorageLocationOverview";
import InventoryItemsTable from "../InventoryItemsTable";
import ExpiryTrendChart from "../charts/ExpiryTrendChart";
import { InventoryItem } from "@/hooks/useInventoryItems";
import { DashboardStats, LocationDistribution, ExpiryTrend } from "@/utils/dashboardUtils";

interface OverviewTabProps {
  stats: DashboardStats;
  locationDistribution: LocationDistribution[];
  items: InventoryItem[];
  expiryTrend: ExpiryTrend[];
  percentages: {
    expiringSoonPercent: number;
    expiredPercent: number;
    healthyPercent: number;
  };
  isLoading: boolean;
  timeFrame: string;
}

export default function OverviewTab({ 
  stats, 
  locationDistribution,
  items,
  expiryTrend,
  percentages,
  isLoading,
  timeFrame
}: OverviewTabProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-expitrack-primary" />
        <span className="ml-3 text-gray-600">Loading dashboard data...</span>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* KPI Cards Section */}
      <KPICards 
        stats={stats}
        isLoading={isLoading}
        percentages={percentages}
        timeFrame={timeFrame}
      />
      
      {/* Storage Location Overview */}
      <StorageLocationOverview 
        locationDistribution={locationDistribution}
        isLoading={isLoading}
        totalInventory={stats.totalInventory}
      />
      
      {/* Inventory Items Table */}
      <InventoryItemsTable 
        items={items}
        isLoading={isLoading}
      />
      
      {/* Expiry Trend Chart */}
      <ExpiryTrendChart 
        expiryTrend={expiryTrend}
      />
    </div>
  );
}
